<template>
  <!--分享排行钻取详情页面  -->
  <div class="sharedetail">
    <div>
      <header class="header">
        <i class="icon-fanhui icon iconfont"
           @click="returnShare"></i>
        <h2>顾问画像</h2>
      </header>
      <div class="header-box">
        <div class="personinfo">
          <div class="infotop">
            <img :src="getAvatar(footPrintInfo.avatar)"
                 class="user-img" />
            <div class="baseinfo">
              <div class="baseinfo-name">{{footPrintInfo.name}}</div>
              <div class="baseinfo-phone">{{footPrintInfo.phone}}</div>
            </div>
          </div>
          <div class="infobottom">
            <span v-for="(item,index) in navList"
                  :key="item.id"
                  @click="getTab(index)"
                  :class="{tabactive:tabIndex==index}">{{item.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 上下拉刷新 -->
    <mt-loadmore :bottom-method="loadBottom"
                 :bottom-all-loaded="allLoaded"
                 :auto-fill="false"
                 ref="loadmore">
      <div class="sharecontent">
        <!-- 行为轨迹 tabIndex==0 -->
        <div class="behaviortrace"
             v-if="tabIndex==0">
          <ul v-if="footPrintList.length>0">
            <li v-for="(item,index) in footPrintList"
                :key="index">
              <div class="behaviortrace-left">
                <div style="width:2.4rem">{{item.created_at.split(' ')[0]}}</div>
                <div class="sharetime">{{item.created_at.split(' ')[1]}}</div>
              </div>
              <div class="behaviortrace-center">
                <div class="circle"></div>
              </div>
              <div class="behaviortrace-right">
                <span class="c_95AFEB">分享</span>
                <span>{{item.title}}</span>
              </div>
            </li>
          </ul>
          <nodata v-if="footPrintList.length<=0"></nodata>
        </div>
        <!-- 行为轨迹 -->
        <!-- 访客列表搜索项 tabIndex==1 -->
        <div class="visitlist"
             v-if="tabIndex==1">
          <div class="searchbox">
            <div class="datelist">
              <span>已选择：</span>
              <span v-for="item in dateList"
                    :key="item.id"
                    @click="getDateIndex(item.id)"
                    :class="{dateactive:item.id==adviserVisitorParams.day}">{{item.name}}</span>
            </div>
            <div class="intentionlist">
              <span>已选择：</span>
              <span v-for="item in intentionList"
                    :key="item.id"
                    @click="getIntentionIndex(item.id)"
                    :class="{dateactive:item.id==adviserVisitorParams.sign_intention_status}">{{item.name}}</span>
            </div>
          </div>
          <!--访客列表主体内容 -->
          <ul class="visitlist-conent"
              v-if="adviserVisitorList.length>0">
            <li class="visitlist-item"
                v-for="(visitItem,visitIndex) in adviserVisitorList"
                :key="visitIndex">
              <div>
                <img v-if="visitItem.avatar" :src="getAvatar(visitItem.avatar)"
                     class="user-img visit-img" />
                  <img v-else src="../../../assets/img/user-avatar.png"
                     class="user-img visit-img" />
                <div class="visit-info">
                  <div class="visit-name">
                    <span>{{visitItem.nickname?visitItem.nickname:'未知'}}</span>
                    <span class="visit-tag"
                          v-if="visitItem.sign_intention_status==1">意向</span>
                  </div>
                  <div class="recentlyvisit">最近访问：<span style="color:#9B9B9B;">{{visitItem.last_browse_project?visitItem.last_browse_project:'未知'}}</span></div>
                </div>
              </div>
              <div>
                <div class="visit-num">访问次数：<span>{{visitItem.counts}}</span></div>
                <div class="visit-time">{{visitItem.last_time.split(' ')[1]}}</div>
                <div class="visit-time">{{visitItem.last_time.split(' ')[0]}}</div>
              </div>
            </li>
          </ul>
          <nodata v-if="adviserVisitorList.length<=0"></nodata>
        </div>
        <!-- 访客列表 -->
        <!-- 关联项目 -->
        <div class="associatedproject"
             v-if="tabIndex==2">
          <ul v-if="relationProList.length>0">
            <li class="projectitem"
                v-for="(proItem,proIndex) in relationProList"
                :key="proIndex">
              <div class="pro-left">
                <img :src="getAvatar(proItem.cover_picture)"
                     class="proimg" />
              </div>
              <div class="pro-right">
                <div class="pro-name">{{proItem.name}}</div>
                <div class="proinfo">
                  <span>人气：<span class="c_222">{{proItem.popularity_num}}</span></span>
                  <span>注册用户数：<span class="c_222">{{proItem.register_num}}</span></span>
                </div>
              </div>
            </li>
          </ul>
          <nodata v-if="relationProList.length<=0"></nodata>
        </div>
        <div v-if="allLoaded&&pagiNation.current_page==pagiNation.last_page"
             style="text-align:center;color:#ccc;">没有更多数据</div>
        <!-- 关联项目 -->
      </div>
    </mt-loadmore>
    <!-- 上下拉刷新 -->
  </div>
</template>
<script>
  import nodata from '../../public/nodata'
  import { Loadmore, Indicator, MessageBox } from 'mint-ui';
  import Vue from 'vue';
  Vue.component(Loadmore.name, Loadmore);
  Vue.use(Loadmore);
  export default {
    components: {
      nodata
    },
    data () {
      return {
        navList: [{ id: '0', name: '行为轨迹' }, { id: '1', name: '访客列表' }, { id: '2', name: '关联项目' }],//顾问画像的tab栏
        tabIndex: 0,//tab栏下标
        dateList: [{ id: '7', name: '近7天' }, { id: '30', name: '近30天' }, { id: '0', name: '全部' }],//日期
        intentionList: [{ id: '0', name: '全部访客' }, { id: '1', name: '意向客户' },],//意向
        footPrintParams: { uuid: '' },//行为轨迹参数
        footPrintList: [],//行为轨迹列表
        footPrintInfo: { name: '', phone: '', avatar: '' },
        allLoaded: false,//上下拉组件默认配置项
        pagiNation: {
          last_page: '',//最后一页
          current_page: '',//当前页
        },
        adviserVisitorParams: {//访客列表
          day: '7',
          sign_intention_status: '0',//全部访客
          uuid: this.$route.query.uuid
        },
        adviserVisitorList: [],//访客列表数据
        relationProList: [],//关联项目数据
      }
    },
    watch: {//监听tab栏的变化
      'tabIndex' (tab) {
        this.allLoaded = false
        let page = 1
        if (tab == 0) {//行为轨迹
          this.getFootPrintData(this.footPrintParams, page)
        }
        if (tab == 1) {//访客列表
          this.getAdviserVisitorsData()
        }
        if (tab == 2) {//关联项目
          this.getRelationProjectData(this.footPrintParams, page)
        }
      }
    },
    methods: {
      returnShare () {//返回分享排行页面
        this.$router.push('/sharerank')
      },
      getTab (index) {//获取当前下标，tab栏
        this.tabIndex = index
      },
      getDateIndex (index) {//访客列表日期筛选
        this.allLoaded = false
        this.adviserVisitorParams.day = index
        this.getAdviserVisitorsData()
      },
      getIntentionIndex (index) {//访客意向
        this.allLoaded = false
        this.adviserVisitorParams.sign_intention_status = index
        this.getAdviserVisitorsData()
      },
      getAvatar (src) {//获取头像地址
        return `${src}`
      },
      getFootPrintData (footPrintParams, page) {//获取行为轨迹数据
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        this.$http.getFootPrint(footPrintParams, page).then(res => {
          if (res.errCode == 0) {
            this.footPrintList = res.data.list
            this.pagiNation.current_page = res.data.pagination.current_page//当前页面
            this.pagiNation.last_page = res.data.pagination.last_page//最后一页
            Indicator.close()
          }else {
            MessageBox('提示', res.errMsg)
          }
        })
      },
      getAdviserVisitorsData () {//获取访客列表内容
        let page = 1
        this.$http.getAdviserVisitors(this.adviserVisitorParams, page).then(res => {
          if(res.errCode == 0){
            this.adviserVisitorList = res.data.list//访客列表数据
            this.pagiNation.current_page = res.data.pagination.current_page//当前页面
            this.pagiNation.last_page = res.data.pagination.last_page//最后一页
          }else {
            MessageBox('提示', res.errMsg)
          }
        })
      },
      getRelationProjectData (footPrintParams, page) {//获取关联项目数据
        this.$http.getRelationProject(footPrintParams, page).then(res => {
          this.pagiNation.current_page = res.data.pagination.current_page//当前页面
          this.pagiNation.last_page = res.data.pagination.last_page//最后一页
          this.relationProList = res.data.list//关联项目
        })

      },
      loadBottom () {//上拉加载更多
        if (this.pagiNation.current_page < this.pagiNation.last_page){
           this.getList();
        }else{
          MessageBox('提示信息','没有更多数据!')
        }
        this.$refs.loadmore.onBottomLoaded();
      },
      getList () {//获取更多数据
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        if (this.pagiNation.current_page < this.pagiNation.last_page) {
          setTimeout(() => {
            if (this.tabIndex == 0) {//行为轨迹数据
              this.$http.getFootPrint(this.footPrintParams, this.pagiNation.current_page + 1).then(res => {
                this.footPrintList = this.footPrintList.concat(res.data.list) //列表数据
                this.pagiNation.current_page = res.data.pagination.current_page//当前页面
                this.pagiNation.last_page = res.data.pagination.last_page//最后一页
                Indicator.close()
                if (this.pagiNation.current_page == this.pagiNation.last_page) {
                  this.allLoaded = true
                  MessageBox('提示', "没有更多数据了")
                }
              })

            }
            if (this.tabIndex == 1) {//访客列表数据
              this.$http.getAdviserVisitors(this.adviserVisitorParams, this.pagiNation.current_page + 1).then(res => {
                this.adviserVisitorList = this.adviserVisitorList.concat(res.data.list)//访客列表数据
                this.pagiNation.current_page = res.data.pagination.current_page//当前页面
                this.pagiNation.last_page = res.data.pagination.last_page//最后一页
                Indicator.close()
                if (this.pagiNation.current_page == this.pagiNation.last_page) {
                  this.allLoaded = true
                  MessageBox('提示', "没有更多数据了")
                }
              })
            }
            if (this.tabIndex == 2) {//关联项目数据
              this.$http.getRelationProject(this.footPrintParams, this.pagiNation.current_page + 1).then(res => {
                this.pagiNation.current_page = res.data.pagination.current_page//当前页面
                this.pagiNation.last_page = res.data.pagination.last_page//最后一页
                this.relationProList = this.relationProList.concat(res.data.list)//关联项目
                Indicator.close()
                if (this.pagiNation.current_page == this.pagiNation.last_page) {
                  this.allLoaded = true
                  MessageBox('提示', "没有更多数据了")
                }
              })
            }
          }, 1000)
        }
      },

    },
    mounted () {
      this.footPrintParams.uuid = this.$route.query.uuid
      let { name, avatar, phone } = this.$route.query
      this.footPrintInfo = {
        name,
        avatar,
        phone
      }
      let page = 1
      this.getFootPrintData(this.footPrintParams, page)//行为轨迹
    }

  }
</script>
<style scoped>
  .sharedetail {
    width: 100%;
    height: 100%;
    background: #fff;
    font-weight: 400;
    color: #353535;
  }
  .header {
    width: 100%;
    background: rgba(223, 234, 255, 1);
    position: fixed;
    z-index: 100;
  }
  .header > h2 {
    font-weight: 400;
    text-align: center;
    font-size: 16px;
    height: 1.1875rem;
    line-height: 1.1875rem;
  }
  .icon-fanhui {
    position: absolute;
    bottom: 12px;
  }
  .header-box {
    background: rgba(223, 234, 255, 1);
    padding-top: 3.5rem;
    height: 2rem;
    border-bottom-right-radius: 4rem 0.4rem;
    border-bottom-left-radius: 4rem 0.4rem;
    font-size: 16px;
  }
  .sharecontent {
    margin-top: 1rem;
  }
  .personinfo {
    width: 9.2rem;
    height: 2.8rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(177, 177, 181, 0.4);
    border-radius: 6px;
    position: relative;
    left: 50%;
    top: -2rem;
    margin-left: -4.6rem;
    padding: 0.2rem 0.4rem 2.7rem;
  }
  .infotop {
    overflow: hidden;
  }
  .user-img {
    width: 1.5rem;
    height: 1.5rem;
    float: left;
    margin-left: 0.6rem;
    border-radius: 50%;
  }
  .baseinfo {
    margin-left: 20px;
    float: left;
  }
  .baseinfo-name {
    margin-top: 0.1rem;
    width:4rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

  }
  .baseinfo-phone {
    color: #b1b1b5;
    margin-top: 0.15rem;
    font-size: 15px;
  }
  .infobottom {
    margin-top: 0.2rem;
    display: flex;
    justify-content: space-around;
    font-size: 14px;
  }
  .infobottom > span {
    display: inline-block;
    padding-top: 0.03rem;
    padding-bottom: 0.2rem;
    font-weight: 300;
  }
  .infobottom .tabactive {
    border-bottom: 2px solid #2e6deb;
    font-weight: 500;
  }
  .behaviortrace {
    padding: 0.2rem 1rem;
  }
  .behaviortrace > ul > li {
    font-size: 13px;
    overflow: hidden;
  }
  .behaviortrace-left {
    float: left;
    margin: 0.6rem 0.3rem 0 0.2rem;
    color: #666666;
  }
  .sharetime {
    text-align: right;
    margin-right: 0.7rem;
  }
  .behaviortrace-center {
    /* 中间线条 */
    float: left;
    height: 2.2rem;
    width: 1px;
    background: #ccc;
  }
  .behaviortrace-right {
    float: left;
    font-size: 12px;
    width: 4.3rem;
    white-space: pre-wrap;
    margin: 0.7rem 0 0 0.6rem;
  }
  .c_95AFEB {
    color: #95afeb;
    font-weight: 300;
  }
  .circle {
    width: 0.38rem;
    height: 0.38rem;
    background: url(../../../assets/img/footprint_circle.png);
    background-size: 100% 100%;
    position: relative;
    left: 50%;
    margin-left: -0.18rem;
    top: 0.8rem;
  }
  /* 访客列表 */
  .visitlist {
    padding: 0.4rem 0.2rem;
  }
  .datelist,
  .intentionlist {
    margin: 0.3rem 0 0;
    color: #9b9b9b;
  }
  .datelist > span:nth-child(2),
  .intentionlist > span:nth-child(2) {
    margin-left: 0;
  }
  .datelist > span,
  .intentionlist > span {
    display: inline-block;
    margin: 0 0.3rem;
  }
  .dateactive {
    border-radius: 10px;
    padding: 0.06rem 0.2rem;
    background: #dfeaff;
    color: #4980f9;
  }
  .visitlist-conent {
    margin-top: 0.5rem;
    font-size: 14px;
    color: #9b9b9b;
  }
  .visitlist-item {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .visitlist-item:after {
    content: "";
    position: absolute;
    bottom: 0;
    background: #d8d8d8;
    width: 100%;
    left: 0px;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  .visit-img {
    float: left;
    margin-left: 0;
    position: relative;
    top: 50%;
    margin-top: -0.8rem;
  }
  .visit-info {
    float: left;
    margin-left: 0.1rem;
  }
  .visit-name {
    margin: 0.1rem 0;
    font-size: 15px;
    color: #353535;
    position: relative;
    width:4.3rem;
    white-space: pre-wrap;
  }
  .recentlyvisit {
    width: 4.4rem;
    font-size: 14px;
    color:#ccc;
  }
  .visit-tag {
    display: inline-block;
    background: #dfeaff;
    color: #4980f9;
    font-size: 13px;
    padding: 0.02rem 0.1rem;
    border-radius: 0.1rem;
    margin-left: 0.2rem;
  }
  .visit-num {
    /* margin-bottom: 0.2rem; */
    text-align: right;
    margin-right: 10px;
    color: #585858;
    font-size: 14px;
  }
  .visit-time {
    text-align: right;
    font-size: 13px;
    margin-right: 0.3rem;
  }
  /* 关联项目 */
  .associatedproject {
    padding-top: 0.4rem;
    padding-bottom: 0.2rem;
  }
  .projectitem {
    width: 9.15rem;
    position: relative;
    left: 50%;
    margin-left: -4.6rem;
    height: 2.45rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(177, 177, 181, 0.4);
    border-radius: 4px;
    margin-top: 0.3rem;
    padding: 0.2rem 0.25rem 0.25rem;
  }
  .pro-left {
    float: left;
  }
  .proimg {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
  }
  .pro-right {
    margin: 0.3rem 0 0 0.3rem;
    float: left;
    font-size: 16px;
  }
  .proinfo {
    margin-top: 0.3rem;
    font-size: 13px;
    color: #9b9b9b;
  }
  .proinfo > span:nth-child(2) {
    margin-left: 1rem;
  }
  .c_222 {
    color: #222222;
    font-size: 16px;
  }
</style>


// WEBPACK FOOTER //
// src/components/drillPage/Share/ShareDetail.vue